import axios from 'axios';
import { getStore, setStore } from './storage';
import { router } from '../router/index';
import { Message } from 'view-design';
import Cookies from 'js-cookie';
import EventBus from "@/libs/eventBus"
import {bqjUrl} from "@/config/config"

// 统一请求路径前缀
let base = '/bqjvip';
// let API_ROOT = 'https://vipback.bqj.cn'; //正式环境
// let API_ROOT = 'https://previpback.bqj.cn' //预发布环境
 let API_ROOT = bqjUrl //测试环境


// 超时设定
axios.defaults.timeout = 15000;

axios.defaults.withCredentials = true

axios.interceptors.request.use(config => {
    return config;
}, err => {
    toast('请求超时');
    return Promise.resolve(err);
});

// http response 拦截器
axios.interceptors.response.use(response => {
    const data = response.data;
    // 根据返回的code值来做不同的处理(和后端约定)

    //if(router.currentRoute.name != 'monitor'){
        switch (data.code) {
            case 210:
                if (localStorage.getItem("springFestival") == '/huodong/chunjie.html/' || localStorage.getItem("springFestival") == '/huodong/chunjie.html') {
                    Cookies.set('userInfo', '');
                        setStore('accessToken', '');
                        Cookies.remove('accessToken');
                        Cookies.remove('accessToken', { domain: 'bqj.cn' });
                        EventBus.emit("logout", 'bbb');
                        var midPagesa = "_empty" + "?time=" + new Date().getTime() / 500;
                        if (localStorage.getItem("springFestival") == '/huodong/chunjie.html/' || localStorage.getItem("springFestival") == '/huodong/chunjie.html' ) {
                            localStorage.removeItem("springFestival")
                            return data;
                        } else {
                            router.push(midPagesa);
                            router.push('/');
                        }
                    return data;
                } else if (localStorage.getItem("zhishichanquanri") == '/huodong/zhishichanquanri.html/' || localStorage.getItem("zhishichanquanri") == '/huodong/zhishichanquanri.html') {
                    Cookies.set('userInfo', '');
                    setStore('accessToken', '');
                    Cookies.remove('accessToken');
                    Cookies.remove('accessToken', { domain: 'bqj.cn' });
                    EventBus.emit("logout", 'bbb');
                    var midPagesa = "_empty" + "?time=" + new Date().getTime() / 500;
                    if (localStorage.getItem("zhishichanquanri") == '/huodong/zhishichanquanri.html/' || localStorage.getItem("zhishichanquanri") == '/huodong/zhishichanquanri.html' ) {
                        localStorage.removeItem("zhishichanquanri")
                        return data;
                    } else {
                        router.push(midPagesa);
                        router.push('/');
                    }
                    return data;
                }else {
                    toast(data.message,function(){
                        Cookies.set('userInfo', '');
                        setStore('accessToken', '');
                        Cookies.remove('accessToken');
                        Cookies.remove('accessToken', { domain: 'bqj.cn' });
                        EventBus.emit("logout", 'bbb');
                        var midPagesa = "_empty" + "?time=" + new Date().getTime() / 500;
                        router.push(midPagesa);
                        router.push('/');
                    });
                }
                


                break;


            //用户未实名认证
            case 213:
                toast(data.message,function(){
                    router.push('/authentication');
                });
                break;


            //VIP未开通
            case 214:
                // let userInfoOldfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
                // if(userInfoOldfo.accountType == 'enterprise'){
                //     toast(data.message,function(){
                //         router.push('/vipEnterprise');
                //     })
                // }else{
                //     toast(data.message,function(){
                //         router.push('/vipPersonal');
                //     })
                // }
                router.push({path: '/huiyuan.html'})
                break;
            // case 215:
            //     let userInfoOLDtw = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
            //     if(userInfoOLDtw.accountType == 'enterprise'){
            //         toast(data.message,function(){
            //             router.push('/vipEnterprise');
            //         })
            //     }else{
            //         toast(data.message,function(){
            //             router.push('/vipPersonal');
            //         })
            //     }
            //     break;
            case 401:
                // 未登录 清除已登录状态
                toast(data.message,function () {
                    Cookies.set('userInfo', '');
                    setStore('accessToken', '');
                    Cookies.remove('accessToken');
                    Cookies.remove('accessToken', { domain: 'bqj.cn' });
                    EventBus.emit("logout", 'bbb');
                    var midPagesb = "_empty" + "?time=" + new Date().getTime() / 500;
                    router.push(midPagesb);
                    router.push('/');
                    // router.push('');
                });

                break;
            case 403:
                // 没有权限
                if (data.message !== null) {
                    toast(data.message);
                } else {
                    toast("未知错误");
                }
                break;
            case 500:
                // 错误
                if (data.message !== null) {
                    if(response.config.url == '/bqjvip/user/sendSmsCode'){

                    }else{
                        toast(data.message);
                    }
                } else {
                    toast("未知错误");
                }
                break;
            default:
                return data;
        }
    //}

    return data;
}, (err) => {
    // 返回状态码不为200时候的错误处理
    console.log(err,'+++++++++++++++++++++++')
    // toast('连接错误，请重试');
    return Promise.resolve(err);
});

export const getRequest = (url, params) => {
    let accessToken = getStore('accessToken');
    return axios({
        method: 'get',
        url: `${API_ROOT}${base}${url}`,
        params: params,
        headers: {
            'accessToken': accessToken && accessToken!='' ? accessToken : ''
        }
    });
};
export const getRequestNobase = (url, params) => {
    let accessToken = getStore('accessToken');
    return axios({
        method: 'get',
        url: `${API_ROOT}${url}`,
        params: params,
        headers: {
            'accessToken': accessToken && accessToken!='' ? accessToken : ''
        }
    });
};

export const postRequest = (url, params) => {
    let accessToken = getStore("accessToken");
    return axios({
        method: 'post',
        url: url == '/hatch/ebaoquanLeavemessage/leavemessage' ? `${API_ROOT}${url}` : `${API_ROOT}${base}${url}`,
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
            }
            ret = ret.substring(0, ret.length - 1);
            return ret;
        }],
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'accessToken': accessToken && accessToken!='' ? accessToken : ''
        }
    });
};

export const postRequestJson = (url, params) => {
    let accessToken = getStore("accessToken");
    return axios({
        method: 'post',
        url: url == '/hatch/ebaoquanLeavemessage/leavemessage' ? `${API_ROOT}${url}` : `${API_ROOT}${base}${url}`,
        data: params,
        headers: {
            'Content-Type': 'application/json',
            'accessToken': accessToken && accessToken!='' ? accessToken : ''
        }
    });
};

export const putRequest = (url, params) => {
    let accessToken = getStore("accessToken");
    return axios({
        method: 'put',
        url: `${API_ROOT}${base}${url}`,
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
            }
            ret = ret.substring(0, ret.length - 1);
            return ret;
        }],
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'accessToken': accessToken && accessToken!='' ? accessToken : ''
        }
    });
};

export const deleteRequest = (url, params) => {
    let accessToken = getStore('accessToken');
    return axios({
        method: 'delete',
        url: `${API_ROOT}${base}${url}`,
        params: params,
        headers: {
            'accessToken': accessToken && accessToken!='' ? accessToken : ''
        }
    });
};

export const uploadFileRequest = (url, params) => {
    let accessToken = getStore('accessToken');
    return axios({
        method: 'post',
        url: `${API_ROOT}${base}${url}`,
        params: params,
        headers: {
            'accessToken': accessToken && accessToken!='' ? accessToken : ''
        }
    });
};

/**
 * 无需token验证的请求 避免旧token过期导致请求失败
 * @param {*} url 
 * @param {*} params 
 */
export const getRequestWithNoToken = (url, params) => {
    return axios({
        method: 'get',
        url: `${API_ROOT}${base}${url}`,
        params: params
    });
};
